
export interface DepositAccountInterface {
    id: number;
    accountNumber: string;
    name: string;
    bank: string;
    logo: string;
    clabe: string;
    store: string;
    typeDeposit: string;
    accountCard: string;
}

export class DepositAccount implements DepositAccountInterface {
    id: number;
    accountNumber: string;
    name: string;
    bank: string;
    logo: string;
    clabe: string;
    store: string;
    typeDeposit: string;
    accountCard: string;

    constructor(d: DepositAccountInterface) {
        this.id = d.id;
        this.accountNumber = d.accountNumber;
        this.name = d.name;
        this.bank = d.bank;
        this.logo = d.logo;
        this.clabe = d.clabe;
        this.store = d.store;
        this.typeDeposit = d.typeDeposit;
        this.accountCard = d.accountCard;
    }
}